import React from 'react'
import { ThemeProvider, Typography, CssBaseline} from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2';
import {theme} from '../../theme.js'
import { TopBar } from '../../components/TopBar/TopBar'
import {Footer} from '../../components/Footer/Footer'
import tiling from '../../images/blue-tile.png'
import useScript from '../../useScript.js'
export const RunawayTrain = () => {
  useScript("https://bookeo.com/widget.js?a=3152JT676U1750739BBCC&type=315269LJXN184873A7488")
  return (
    
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <Grid container spacing={0} style={{backgroundImage:`url(${tiling})`, backgroundAttachment:"fixed"}}>
        <Grid item xs={12}>
          <TopBar/>
        </Grid>
        <Grid item xs={12} id="iframewrapper" marginLeft={"52px"} marginRight={"40px"}>
         </Grid>
      <Footer/>
      </Grid>
    </ThemeProvider>
    )
}
